var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Schemas_1;
import { JsonConverter, JsonSchema, MapConverter } from '@symon-ai/wisepipe-serialize';
import './columnMetadata'; // force import for JsonSchema
import { ColumnMetadata } from './columnMetadata';
const schema = {
    $id: 'urn:wisepipe-common-pipe:Schemas',
    type: 'object',
    properties: {
        schemas: {
            type: 'object',
            additionalProperties: {
                type: 'array',
                items: { $ref: 'urn:wisepipe-common-pipe:ColumnMetadata' },
                maxItems: 1000,
                uniqueItemProperties: ['name']
            }
        }
    },
    required: ['schemas']
};
let Schemas = Schemas_1 = class Schemas {
    constructor(schemas) {
        if (schemas.size > Schemas_1.MAX_ITEMS) {
            throw Error(`data.schemas should NOT have more than ${Schemas_1.MAX_ITEMS} items`);
        }
        schemas.forEach((value, key, map) => {
            if (new Set(value.map((c) => c.column.name)).size !== value.length) {
                throw Error(`data.schemas['${key}'] should pass "uniqueItemProperties" keyword validation`);
            }
        });
        this.schemas = new Map(schemas);
        // Costly to do and not required as it's enforced by Typescript, serialize and deserialize.
        // JSON.validate(this, Schemas);
    }
    at(key) {
        if (this.schemas.has(key))
            return this.schemas.get(key);
        return undefined;
    }
    has(key) {
        return this.schemas.has(key);
    }
    get size() {
        return this.schemas.size;
    }
    get names() {
        return Array.from(this.schemas.keys());
    }
    columns() {
        const metadatas = Array.from(this.schemas.values());
        const schemas = metadatas.reduce((prev, current) => prev.concat(current), []);
        const columns = schemas.map((val) => val.column);
        return columns;
    }
    columnMetadata() {
        const metadatas = Array.from(this.schemas.values());
        return metadatas.reduce((prev, current) => prev.concat(current), []);
    }
    static merge(...schemas) {
        const merged = new Map();
        for (const schema of schemas) {
            for (const item of schema.schemas.entries()) {
                merged.set(item[0], item[1]);
            }
        }
        return new Schemas_1(merged);
    }
};
Schemas.MAX_ITEMS = schema.properties.schemas.additionalProperties.maxItems;
__decorate([
    JsonConverter(new MapConverter(ColumnMetadata))
], Schemas.prototype, "schemas", void 0);
Schemas = Schemas_1 = __decorate([
    JsonSchema(schema)
], Schemas);
export { Schemas };
(function (Schemas) {
    Schemas.empty = new Schemas(new Map());
})(Schemas || (Schemas = {}));
//# sourceMappingURL=schemas.js.map